/**
 * EmojiPickerPopover — Picker emoji esteso con categorie
 */

import { useRef, useEffect } from 'react';

const EMOJI_CATEGORIES: { label: string; emojis: string[] }[] = [
  { label: 'Frequenti', emojis: ['👍','❤️','😂','😮','😢','🙏','🔥','✅','👏','🎉','💯','😍','🤝','👋','💪'] },
  { label: 'Faccine', emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','🤐','🤨','😐','😑','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤧','🥵','🥶','🥴','😵','🤯','🤠','🥳','😎','🤓','🧐','😕','😟','🙁','😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿'] },
  { label: 'Mani', emojis: ['👋','🤚','🖐️','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','🦾','🦿','🦵','🦶','👂','🦻','👃','👀','👁️','👅','👄'] },
  { label: 'Oggetti', emojis: ['💼','📱','💻','⌨️','🖥️','🖨️','🖱️','📷','📸','📹','🎥','📞','☎️','📟','📠','📺','📻','🎙️','🎚️','🎛️','🧭','⏱️','⏰','📡','🔋','💡','🔦','🕯️','🪔','🧯','🛢️','💰','💴','💵','💶','💷','💸','💳','🧾','📦','📫','📬','📭','📮','📯','📜','📃','📄','📑','🗒️','🗓️','📆','📅','🗑️','📋','📁','📂','🗂️','🗃️','🗄️','🗑️','🔒','🔓','🔏','🔐','🔑','🗝️','🔨','🪓','⛏️','⚒️','🛠️','🗡️','⚔️','🔫','🏹','🛡️','🪚','🔧','🪛','🔩','⚙️','🗜️','⚖️','🦯','🔗','⛓️','🧰','🧲','🪜'] },
  { label: 'Natura', emojis: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐔','🐧','🐦','🐤','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞','🐜','🦟','🦗','🕷️','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍','🦧','🦣','🐘','🦛','🦏','🐪','🐫','🦒','🦘','🦬','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕','🐩','🦮','🐕‍🦺','🐈','🐈‍⬛','🪶','🐓','🦃','🦤','🦚','🦜','🦢','🦩','🕊️','🐇','🦝','🦨','🦡','🦫','🦦','🦥','🐁','🐀','🐿️','🦔'] },
  { label: 'Cibo', emojis: ['🍕','🍔','🌮','🌯','🥗','🍜','🍝','🍛','🍱','🍣','🍤','🦪','🥚','🍳','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🥪','🥙','🧆','🥚','🧀','🥗','🍱','🍘','🍙','🍚','🍛','🍜','🍝','🍞','🥖','🥨','🧀','🥗','🍲','🫕','🥣','🥫','🧂','🍿','🧈','🧁','🎂','🍰','🍮','🍭','🍬','🍫','🍩','🍪','🌰','🥜','🍯','🧃','🥤','🧋','🍵','☕','🫖','🍺','🍻','🥂','🍷','🫗','🥃','🍸','🍹','🧉','🍾'] },
  { label: 'Sport', emojis: ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🏓','🏸','🏒','🥊','🥋','🎯','⛳','🎿','🛷','🥅','🎣','🤿','🎽','🎿','🛹','🛼','🪂','🏋️','🤸','⛹️','🤺','🏇','🧘','🏊','🚴','🧗','🏌️','🏄','🚵','🤾','🏇','🤼','🤹'] },
  { label: 'Simboli', emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','☮️','✝️','☪️','🕉️','☸️','✡️','🔯','🕎','☯️','☦️','🛐','⛎','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓','🆔','⚛️','🉑','☢️','☣️','📴','📳','🈶','🈚','🈸','🈺','🈷️','✴️','🆚','💮','🉐','㊙️','㊗️','🈴','🈵','🈹','🈲','🅰️','🅱️','🆎','🆑','🅾️','🆘','❌','⭕','🛑','⛔','📛','🚫','💯','💢','♨️','🚷','🚯','🚳','🚱','🔞','📵','🔕','🔇','🔈','🔉','🔊','📢','📣','🔔','🔕','🎵','🎶','✅','❎','🔱','⚜️','🔰','♻️','✔️','🔛','🔜','🔚','🔙','🔝','🛐','🔀','🔁','🔂','⏩','⏪','⏫','⏬','⏭️','⏮️','⏯️','🔼','🔽','⏸️','⏹️','⏺️','🎦','🔅','🔆','📶','📳','📴','🔌','💤','🌐','♾️','📧','📨','📩','✉️','📪','📫','📬','📭','📮','🗳️','✏️','✒️','🖊️','🖋️','📝','📁','📂','📅','📆','🗒️','🗓️','📇','📈','📉','📊','📋','📌','📍','📎','🖇️','📏','📐','✂️','🗃️','🗄️','🗑️','🔒','🔓','🔏','🔐','🔑','🗝️','🔨','🪓','⛏️','⚒️','🛠️','🗡️','⚔️','💣','🪃','🏹','🛡️','🔧','🔩','⚙️','🗜️','🔗','⛓️','🧰','🧲','⚗️','🔭','🔬','🩺','💊','💉','🩸','🩹','🩼','🩻','🚪','🛗','🪞','🪟','🛋️','🪑','🚽','🪠','🚿','🛁','🪤','🪒','🧴','🧷','🧹','🧺','🧻','🪣','🧼','🫧','🪥','🧽','🪜','🛒'] },
];

interface Props {
  onEmojiSelect: (emoji: string) => void;
  onClose: () => void;
  /** Resta aperto dopo la scelta (campo di scrittura: si inseriscono piu' emoji). */
  keepOpen?: boolean;
  /** Lato a cui si allinea il pannello rispetto al pulsante. */
  align?: 'left' | 'right';
}

export function EmojiPickerPopover({ onEmojiSelect, onClose, keepOpen = false, align = 'right' }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    // Esc chiude solo il pannello emoji, non tutto il pannello Messaggi.
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); onClose(); } };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute z-50 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-[rgba(55,53,47,0.09)] dark:border-white/10 w-72 max-h-80 overflow-y-auto"
      style={{ bottom: '100%', ...(align === 'left' ? { left: 0 } : { right: 0 }), marginBottom: '4px' }}
      role="dialog"
      aria-label="Scegli un'emoji"
    >
      {EMOJI_CATEGORIES.map((cat) => (
        <div key={cat.label} className="px-3 py-2">
          <p className="text-[10px] font-semibold text-[#787774] uppercase tracking-wide mb-1.5">{cat.label}</p>
          <div className="flex flex-wrap gap-0.5">
            {cat.emojis.map((emoji, i) => (
              <button
                key={`${emoji}-${i}`}
                type="button"
                aria-label={`Emoji ${emoji}`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => { onEmojiSelect(emoji); if (!keepOpen) onClose(); }}
                className="w-8 h-8 flex items-center justify-center text-lg hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/10 rounded transition-colors"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
